import { useMutation, useQuery } from '@tanstack/react-query';
import { api } from './interceptor';

// GET: /bill/discos/
export const useDiscosList = () =>
    useQuery({
        queryKey: ["bill_discos_list"],
        queryFn: () => api.get(`/bill/discos/`).then(res => res.data),
    });

// POST: /bill/discos/create/
export const useCreateDisco = () =>
    useMutation({
        mutationFn: (data: Record<string, any>) => api.post(`/bill/discos/create/`, data).then(res => res.data),
    });

// GET: /bill/discos/{id}/
export const useDiscoDetails = (id: string | number) =>
    useQuery({
        queryKey: ["bill_discos_read", id],
        queryFn: () => api.get(`/bill/discos/${id}/`).then(res => res.data),
        enabled: !!id,
    });

// DELETE: /bill/discos/{id}/delete/
export const useDeleteDisco = () =>
    useMutation({
        mutationFn: (id: string | number) => api.delete(`/bill/discos/${id}/delete/`).then(res => res.data),
    });

// PUT: /bill/discos/{id}/update/
export const useUpdateDisco = () =>
    useMutation({
        mutationFn: ({ id, data }: { id: string | number, data: Record<string, any> }) =>
            api.put(`/bill/discos/${id}/update/`, data).then(res => res.data),
    });

// POST: /bill/purchase_bill/
export const usePurchaseBill = () =>
    useMutation({
        mutationFn: (data: Record<string, any>) => api.post(`/bill/purchase_bill/`, data).then(res => res.data),
    });

// GET: /bill/validate-meter/
export const useValidateMeter = (meter_number: string, disco_id: string | number, meter_type: string) =>
    useQuery({
        queryKey: ["bill_validate_meter", meter_number, disco_id, meter_type],
        queryFn: () => api.get(`/bill/validate-meter/`, { params: { meter_number, disco_id, meter_type } }).then(res => res.data),
        enabled: false,
        retry: false,
    });


